var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12387_385804)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "#02528B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.8248 125.597C-25.8967 129.502 -19.5319 129.486 -15.6139 125.558C-11.6959 121.632 -0.634842 104.182 -4.56689 100.275C-8.497 96.3675 -25.9313 107.485 -29.8493 111.413C-33.7692 115.341 -33.7569 121.691 -29.8248 125.597Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.331 -9.03774C113.566 -1.96761 113.686 9.62407 106.595 16.8538C99.5071 24.0806 75.6544 36.6892 68.4189 29.6181C61.1806 22.5519 73.3005 -1.51979 80.3902 -8.74659C87.4808 -15.9783 99.0927 -16.1059 106.331 -9.03774Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.27 -1.87448C110.208 3.75558 109.64 12.3199 103.993 17.2563C98.3505 22.1908 88.1829 25.2311 83.2438 19.602C78.301 13.9709 80.461 1.80599 86.1041 -3.1314C91.751 -8.06679 100.329 -7.5036 105.27 -1.87448Z",
    fill: "#0076AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.3991 7.52928C100.282 10.7376 98.9995 16.5742 94.5364 20.5679C90.0773 24.5599 84.1268 25.1964 81.245 21.9911C78.3634 18.7818 79.6426 12.946 84.1038 8.95221C88.5668 4.96046 94.5164 4.32288 97.3991 7.52928Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.1165 22.0671C-42.8285 31.4784 -38.1973 42.1054 -28.7694 45.8016C-19.346 49.4977 7.57601 51.2478 11.2868 41.836C15.0004 32.4282 -5.90441 15.4185 -15.3297 11.7233C-24.7552 8.02497 -35.4049 12.657 -39.1165 22.0671Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.586 58.9528C117.918 97.9105 101.575 134.43 62.5376 142.779C23.4989 151.127 -6.35113 124.486 -14.6824 85.5283C-23.0137 46.5706 -6.67128 10.0495 32.3674 1.7009C71.4047 -6.64743 101.255 19.9951 109.586 58.9528Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.591 55.7728C107.856 89.7446 93.6042 121.59 59.5631 128.87C25.5219 136.15 -0.506943 112.919 -7.77201 78.9467C-15.0371 44.9748 -0.786333 13.1309 33.2548 5.85102C67.2959 -1.42885 93.3258 21.8009 100.591 55.7728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.129 53.2704C103.351 49.4754 103.074 45.6295 102.254 41.7926C96.4496 14.653 65.6216 -1.76146 33.3972 5.12989C1.17281 12.0212 -20.2452 39.6088 -14.4413 66.7484C-13.5041 71.1305 -11.9146 75.233 -9.7721 79.0029C-10.0397 82.5283 -9.81715 86.0932 -9.05818 89.6422C-3.65914 114.888 26.8407 129.768 59.0651 122.877C91.2894 115.985 113.036 89.9327 107.637 64.6864C106.761 60.5922 105.225 56.7707 103.129 53.2704Z",
    fill: "url(#paint0_radial_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1839 62.2871C72.4497 58.8539 68.8488 56.3753 63.6209 55.1415C63.6172 55.1044 63.6175 55.0663 63.6151 55.0289C58.3798 53.7869 51.5102 53.7954 44.251 55.3478C37.1171 56.8735 30.9359 59.6067 26.6744 62.8066C26.6881 62.8444 26.7032 62.8819 26.7183 62.9195C26.7121 62.9236 26.7059 62.9277 26.7011 62.9316C26.7011 62.9316 26.7017 62.9343 26.7033 62.9353C22.3191 66.2331 19.9694 70.0264 20.7139 73.5081C22.1818 80.3718 35.1171 83.4266 49.6059 80.3281L49.7392 80.2996C56.9594 78.7556 63.2034 75.9737 67.467 72.7242C67.4592 72.7076 67.446 72.6922 67.4355 72.6761C71.6655 69.4212 73.9147 65.7042 73.1839 62.2871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.05 61.6704C74.5194 68.5413 63.9658 76.623 49.478 79.7213C34.9901 82.8196 22.0542 79.7613 20.5848 72.8904C19.1154 66.0194 29.669 57.9378 44.1569 54.8395C58.6447 51.7412 71.5807 54.7995 73.05 61.6704Z",
    fill: "url(#paint1_linear_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3365 80.0122C35.5528 81.2349 42.3845 81.2185 49.6058 79.6742C56.8271 78.1299 63.068 75.3506 67.3279 72.1014C62.8256 65.4241 54.5415 61.7894 46.1642 63.581C37.7869 65.3725 31.714 72.0774 30.3365 80.0122Z",
    fill: "url(#paint2_radial_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.8026 67.6217C56.3542 70.2013 52.8032 73.1466 47.8717 74.2013C42.9388 75.2562 38.4924 74.0212 37.9408 71.4415C37.3891 68.8619 40.9414 65.9163 45.8743 64.8614C50.8058 63.8068 55.2509 65.0421 55.8026 67.6217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.144 54.8461C37.0114 56.3714 30.8289 59.105 26.5687 62.3045C27.4172 64.7701 29.9959 66.2696 32.6132 65.7098L59.3736 59.987C61.9518 59.4356 63.6791 57.0785 63.5082 54.5272C58.2745 53.2862 51.4046 53.2934 44.144 54.8461Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1531 54.8441C37.5553 56.255 31.7691 58.4511 27.8282 61.4109C28.6129 63.6905 30.999 65.1258 33.421 64.6078L58.1689 59.3153C60.5545 58.8052 62.1458 56.5699 61.9865 54.2114C57.1484 53.0616 50.8668 53.4083 44.1531 54.8441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5413 56.7011C51.5163 55.2094 58.1264 55.1467 63.2745 56.2443C63.4482 55.6604 63.525 55.0381 63.4823 54.4034C58.2486 53.1624 51.3787 53.1696 44.1182 54.7223C36.9842 56.248 30.803 58.9812 26.5431 62.1821C26.7503 62.7887 27.0643 63.3344 27.4556 63.8074C31.6944 60.7586 37.6714 58.1702 44.5413 56.7011Z",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6812 42.1999C31.4215 50.338 26.2209 58.3481 18.0659 60.0921C9.91089 61.836 1.89031 56.6534 0.14994 48.5153C-1.59043 40.3772 3.60859 32.3661 11.7636 30.6221C19.9186 28.8781 27.9408 34.0618 29.6812 42.1999Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8197 31.4916C83.5604 39.6311 78.36 47.6425 70.2036 49.3868C62.0486 51.1308 54.0291 45.9465 52.2885 37.807C50.5481 29.6689 55.7461 21.6594 63.9011 19.9154C72.0574 18.1712 80.0793 23.3535 81.8197 31.4916Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6635 21.1891C57.758 30.9833 51.4994 40.6268 41.6808 42.7266C31.8676 44.8252 22.2122 38.585 20.1177 28.7908C18.0232 18.9966 24.2817 9.35311 34.095 7.2545C43.9136 5.15475 53.5689 11.3949 55.6635 21.1891Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6873 42.6254C29.1925 49.6639 24.6952 56.5958 17.6394 58.1047C10.5849 59.6133 3.64719 55.1269 2.14197 48.0884C0.636469 41.0485 5.13327 34.121 12.1877 32.6123C19.2435 31.1034 26.1818 35.5856 27.6873 42.6254Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8608 42.8022C28.2688 49.386 24.0618 55.867 17.4643 57.278C10.8668 58.6889 4.37711 54.4954 2.96912 47.9116C1.56114 41.3277 5.76807 34.8467 12.3656 33.4358C18.9631 32.0249 25.4528 36.2184 26.8608 42.8022Z",
    fill: "url(#paint3_radial_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3382 43.9858C22.0955 47.5273 19.8326 51.0134 16.2838 51.7724C12.735 52.5313 9.24416 50.2756 8.4868 46.7342C7.72944 43.1927 9.99236 39.7065 13.5412 38.9476C17.09 38.1887 20.5808 40.4444 21.3382 43.9858Z",
    fill: "url(#paint4_radial_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9209 44.7141C18.2751 46.3702 17.2155 48.0025 15.556 48.3574C13.8951 48.7126 12.2619 47.6562 11.9078 46.0001C11.5536 44.3439 12.6118 42.7119 14.2727 42.3567C15.9322 42.0018 17.5667 43.058 17.9209 44.7141Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3002,
    cy: 42.6185,
    rx: 3.65837,
    ry: 2.80384,
    transform: "rotate(-12.0712 14.3002 42.6185)",
    fill: "url(#paint5_linear_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8269 31.9202C81.3322 38.9587 76.8343 45.8879 69.7798 47.3965C62.7254 48.9052 55.7868 44.4217 54.2816 37.3832C52.7761 30.3434 57.2737 23.4128 64.3282 21.9042C71.3826 20.3955 78.3214 24.8804 79.8269 31.9202Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.9992 32.0976C80.4072 38.6813 76.2003 45.1621 69.603 46.573C63.0057 47.9839 56.5161 43.7905 55.1081 37.2069C53.7002 30.6232 57.907 24.1424 64.5044 22.7315C71.1017 21.3206 77.5913 25.514 78.9992 32.0976Z",
    fill: "url(#paint6_radial_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4804 33.2774C74.2378 36.8193 71.9747 40.3058 68.4255 41.0648C64.8764 41.8238 61.3852 39.5679 60.6277 36.0261C59.8703 32.4842 62.1335 28.9977 65.6826 28.2387C69.2318 27.4797 72.723 29.7356 73.4804 33.2774Z",
    fill: "url(#paint7_radial_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0586 34.0089C70.4128 35.665 69.3556 37.2954 67.696 37.6503C66.0351 38.0055 64.4023 36.9504 64.0481 35.2943C63.6939 33.6382 64.7524 32.0075 66.4133 31.6523C68.0729 31.2974 69.7044 32.3528 70.0586 34.0089Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.3617,
    cy: 31.485,
    rx: 3.65837,
    ry: 2.80384,
    transform: "rotate(-12.0712 66.3617 31.485)",
    fill: "url(#paint8_linear_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6307 21.6231C55.499 30.3594 49.9145 38.9591 41.1628 40.8307C32.4057 42.7034 23.795 37.1395 21.9267 28.4032C20.0584 19.6669 25.6402 11.0678 34.3974 9.19509C43.1491 7.32348 51.7624 12.8869 53.6307 21.6231Z",
    fill: "#1496DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6031 21.843C54.3504 30.0137 49.1295 38.0567 40.9419 39.8077C32.7543 41.5586 24.7004 36.3545 22.9531 28.1838C21.2057 20.0132 26.4266 11.9701 34.6142 10.2191C42.8019 8.46816 50.8557 13.6723 52.6031 21.843Z",
    fill: "url(#paint9_radial_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7527 23.3076C46.6927 27.7032 43.884 32.0301 39.4793 32.972C35.0746 33.914 30.7419 31.1143 29.8019 26.7188C28.8619 22.3232 31.6705 17.9963 36.0752 17.0543C40.4799 16.1123 44.8127 18.912 45.7527 23.3076Z",
    fill: "url(#paint10_radial_12387_385804)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5096 24.2156C41.9491 26.271 40.6353 28.2951 38.5757 28.7355C36.5133 29.1766 34.4879 27.8666 34.0483 25.8113C33.6088 23.7559 34.921 21.7308 36.9833 21.2897C39.043 20.8493 41.07 22.1603 41.5096 24.2156Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.9405,
    cy: 21.08,
    rx: 4.53969,
    ry: 3.48237,
    transform: "rotate(-12.0712 36.9405 21.08)",
    fill: "url(#paint11_linear_12387_385804)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12387_385804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9544 58.0331) rotate(77.9288) scale(72.7359 86.925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224916,
    stopColor: "#E4E4E4",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521135,
    stopColor: "#C530B6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12387_385804",
    x1: 23.0275,
    y1: 85.2859,
    x2: 17.7629,
    y2: 60.3411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12387_385804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.8848 71.6278) rotate(-12.0712) scale(14.5941 6.3492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1622"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12387_385804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9146 45.3574) rotate(-12.0712) scale(12.2159 12.1906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12387_385804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9136 45.3583) rotate(-12.0712) scale(6.57098 6.55737)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12387_385804",
    x1: 14.3069,
    y1: 39.8147,
    x2: 14.3069,
    y2: 42.5608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12387_385804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.0541 34.6516) rotate(-12.0712) scale(12.2156 12.1903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_12387_385804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.0542 34.6516) rotate(-12.0712) scale(6.57164 6.55802)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12387_385804",
    x1: 66.3683,
    y1: 28.6811,
    x2: 66.3683,
    y2: 31.4273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12387_385804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7785 25.0128) rotate(-12.0712) scale(15.1602 15.1288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_12387_385804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7772 25.0133) rotate(-12.0712) scale(8.15574 8.13883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12387_385804",
    x1: 36.9487,
    y1: 17.5977,
    x2: 36.9487,
    y2: 21.0084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12387_385804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterIcon2);
export default __webpack_public_path__ + "static/media/MonsterIcon2.1a552458c8457530da4560c33a72200c.svg";
export { ForwardRef as ReactComponent };